import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import FormButton from '../../../library/form/components/FormActionButton2';

const ProjectHoldHistoryRow = (props) => {
    const { formObject, rowKey, index } = props;

    return (
        <ul>
            <li className="uiColumnCenter uiColumn50">
                {index}
            </li>
            <li className='uiColumnCenter uiColumn150' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "reason" }} />
            </li>
            <li className='uiColumnCenter uiColumn70' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taskName" }} />
            </li>
            <li className='uiColumnCenter uiColumn150' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "holdDate" }} />
            </li>
            <li className='uiColumnCenter uiColumn100' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "holdComment" }} />
            </li>
            <li className='uiColumnCenter uiColumn100' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isResumed" }} />
            </li>
            <li className='uiColumnCenter uiColumn150' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "resumeDate" }} />
            </li>
            <li className='uiColumnCenter uiColumn100' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "resumeComment" }} />
            </li>
            <li className='uiColumnCenter uiColumn100' >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "holdDays" }} />
            </li>
            <li className='uiColumnCenter uiWidth100' >
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                    className="" ></FormButton>

                 <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del",  actionParam: {isResume:1}, containerKey: "" }}
                    className="" ></FormButton>
            </li>
        </ul>
    )
}

export default ProjectHoldHistoryRow